import {
  Plane,
  Eye,
  MessageSquare,
  Bell,
  HardHat,
  Bot,
  Monitor,
  FileText,
  BarChart3,
  Code2,
  Box,
  Cpu,
  Shield,
  Wifi,
  Camera,
  Zap,
  Globe,
  Lock,
  Settings,
  Database,
  Cloud,
  Smartphone,
  Truck,
  Heart,
  Star,
} from "lucide-react";

// Map icon string names from JSON config to actual React components
// Add new icons here when needed in showcases.json
export const iconMap = {
  Plane,
  Eye,
  MessageSquare,
  Bell,
  HardHat,
  Bot,
  Monitor,
  FileText,
  BarChart3,
  Code2,
  Box,
  Cpu,
  Shield,
  Wifi,
  Camera,
  Zap,
  Globe,
  Lock,
  Settings,
  Database,
  Cloud,
  Smartphone,
  Truck,
  Heart,
  Star,
};

// Resolve icon string to component, fallback to Box
export const getIcon = (iconName) => {
  return iconMap[iconName] || Box;
};
